import { render, staticRenderFns } from "./RecordMessageModal.vue?vue&type=template&id=020880bb&scoped=true"
import script from "./RecordMessageModal.vue?vue&type=script&lang=js"
export * from "./RecordMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020880bb",
  null
  
)

export default component.exports